module.exports = __webpack_public_path__ + "static/media/tsukasa-aoi-win.e298ec94.jpg";